export const notFound = {
  title: 'Ups! Pagina nu a fost găsită.',
  description:
    'Se pare că pagina pe care o căutați nu există. Verificați adresa URL sau reveniți la pagina principală.',
  backToHome: 'Înapoi la pagina principală',
  imageAlt: '404 – pagina nu a fost găsită',
};
